import { render, staticRenderFns } from "./HandlingUnits.vue?vue&type=template&id=584e9d83&scoped=true&"
import script from "./HandlingUnits.vue?vue&type=script&lang=js&"
export * from "./HandlingUnits.vue?vue&type=script&lang=js&"
import style0 from "./HandlingUnits.vue?vue&type=style&index=0&id=584e9d83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584e9d83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584e9d83')) {
      api.createRecord('584e9d83', component.options)
    } else {
      api.reload('584e9d83', component.options)
    }
    module.hot.accept("./HandlingUnits.vue?vue&type=template&id=584e9d83&scoped=true&", function () {
      api.rerender('584e9d83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business-orders/HandlingUnits.vue"
export default component.exports